import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GlobalStorage } from 'src/app/core/Gloabl/Global';
import { HospitalService } from 'src/app/hospital/hospital.service';
import { CustomvalidationService } from 'src/app/services/customvalidation.service';
import { environment } from '../../../../../environments/environment.prod';
import { UserProfile } from '../UserDetails/user.profile';
import { Notification } from '../../../../core/Notifications/Notification';
import { WellnessRegisterOtpComponent } from './wellness-register-otp/wellness-register-otp.component';

@Component({
  selector: 'app-wellness-register',
  templateUrl: './wellness-register.component.html',
  styleUrls: ['./wellness-register.component.scss']
})
export class WellnessRegisterComponent implements OnInit {

  Registerform: FormGroup;
  clientId = 'Global_spa';
  result: Object;
  hospitaltypedd: any;
  Id: any;
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$";
  constructor(private fb: FormBuilder,private service: HospitalService, private dialog:MatDialog,
    private router: Router, private Http: HttpClient, private notify: Notification
    , private global: GlobalStorage, private authProfile: UserProfile, private customValidator:CustomvalidationService
  ) { this.Registerform = this.fb.group({
    'HOS_HospitalName': ['',[Validators.pattern("^\\S{0}.{0,24}\\S{1}$"), Validators.required, this.nameValidatorss]],
    'HOS_HospitalPhoneNo': ['',[Validators.pattern("[0-9]{10}$"), this.nameValidator, Validators.minLength(10), Validators.maxLength(10), Validators.required]],
    'HOS_HospitalEmail': ['',[Validators.required, Validators.pattern(this.emailPattern)]],
    'OwnerName':['',[Validators.pattern("^\\S{0}.{0,24}\\S{1}$"), Validators.required, this.nameValidatorss]],
    'Hos_Type_Id':[],
  //   'Password': ['', Validators.compose([Validators.required, 
  //     this.customValidator.patternValidator(new RegExp(/[^A-Za-z0-9]/), { hasNonAlphanum: true }),
  //     this.customValidator.patternValidator(new RegExp(/[A-Z]/), { hasCapitalCase: true }),
  //     this.customValidator.patternValidator(new RegExp(/[a-z]/), { hasSmallCase: true }),
  //     Validators.minLength(6)
  //  ])],
    //  'ConfirmPassword': ['', [Validators.required]],
     
   },
    // { validators: this.customValidator.MatchValidators('Password', 'ConfirmPassword') }
   );
 }

 public checkError = (controlName: string, errorName: string) => {
   return this.Registerform.controls[controlName].hasError(errorName);
 }
//  hospital=new FormGroup({
//   Hos_Type_Id: new FormControl(''),
//  })
 nameValidatorss(control: any): { [key: string]: boolean } {
   const nameRegexp: RegExp = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?/\/,/0-9]/;
   // const spaceexp: RegExp =/[/\s/g, '']/

   if (control.value && nameRegexp.test(control.value)) {
     return { invalidName: true };
   }
 }

 nameValidator(control: any): { [key: string]: boolean } {
   const nameRegexp: RegExp = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?/\s/g,''/a-zA-Z]/;
   // const spaceexp: RegExp =/[/\s/g, '']/

   if (control.value && nameRegexp.test(control.value)) {
     return { invalidName: true };
   }
 }

 get f(): { [key: string]: AbstractControl } {
  return this.Registerform.controls;
}
// opendialog() {
//   const dialogRef = this.dialog.open(OtpboxComponent, {
//     data: this.Registerform.value,
//     disableClose: true
//   });
// }
  ngOnInit(): void {
    this.Get_hospitaltype();
  
  }
  // save() {
  //   const formdata = new FormData();
  //   formdata.append('Hos_Type_Id', this.hospital.value.Hos_Type_Id);
  // }
  Get_hospitaltype() {
    this.service.Get_hospital_type()
      .subscribe((data) => {
        this.hospitaltypedd = data
      })
  }
  SendOTP() {

    this.Http.get(`${environment.Login_URL}` + `api/Authentication/SendOTP/${this.Registerform.value.HOS_HospitalPhoneNo}/${'1407167973890825627'}`).subscribe((data: any) => {
      console.log('Data', data);
      this.Id = data.Id;
      if (data.IsSuccess) {
        let Data = {
          "HOS_HospitalName": this.Registerform.value.HOS_HospitalName,
          "OwnerName":this.Registerform.value.OwnerName,
          "HOS_HospitalPhoneNo": this.Registerform.value.HOS_HospitalPhoneNo,
          "HOS_HospitalEmail": this.Registerform.value.HOS_HospitalEmail,
          "Password": this.Registerform.value.Password,
          "ConfirmPassword": this.Registerform.value.ConfirmPassword,
          "Hos_Type_Id": this.Registerform.value.Hos_Type_Id,
          "Id": this.Id,
          "OTP": ""
        };
        const dialogRef = this.dialog.open(WellnessRegisterOtpComponent, {
          data: Data,
          disableClose: true
        });
      }
      else if (!data.IsSuccess) {
        this.notify.errorsmsg(data.Message);
      }



    })


  }
  
}